// extracted by mini-css-extract-plugin
module.exports = {"skinReportWrapper":"ibFXVl2tdu1UVd9tSC62G","describe":"_2podaIDajABFUQ_yhuOqUa","skinReportContent":"SoyOfabKq_1G6klG9Tire"};